import request from '@/utils/request'

export function getLongUrlByShortID (id) {
  return request({
    url: '/api/v1/shortUrls/' + id,
    method: 'GET'
  })
}

export function updateClickByShortID (id) {
  return request({
    url: '/api/v1/shortUrls/' + id,
    method: 'POST'
  })
}